import React from 'react';
import './get.css'

const Get = () => {
  return (
    <div className="get section__margin">
        <div className="get-main">
          <p>Request Early Access to Get Started</p>
          
          <h1>Register today & start exploring the endless possiblities.</h1>   
        </div>
        <div className="get-btn">
            <button>Get Started</button>
        </div>

    </div>
  )
}

export default Get